const en = {
    greetings: 'Registration in the application',
    firstStepTitle: 'First step - email address verification',

    emailIsConfirmTitle: 'Your email has been confirmed',
    secondStepTitle: 'Second step - complete registration, enter your name and password to log in',

    confirmEmailAddress: 'Confirm email address',

    name: 'Name',
    email: 'Email',
    telegram: 'Telegram',
    verificationEmailLabel: "Enter your email address to receive a verification code",
    password: 'Password',
    verificationCodeLabel: 'Enter the code sent to your email',
    verificationEmailButton: "Send code to email",
    button: 'Sign up',

    question: 'Already registered?',

    signin: 'Sign in',
    passwordRecovery: 'Password recovery',
    enterNewPassword: 'Enter a new password',
    changePassword: 'Change password',
    enterEmail: 'Enter your email, a recovery code will be sent to it',
    codeSent: 'The code has been sent to your email',

    mistakesName: {
        theUsernameFieldMustBeFilledIn: 'Name must be filled in',
        theUsernameMustBeAtLeastCharactersLong: 'Username must be at least 2 characters long.',
        theUsernameShouldOnlyContainLatinLettersCyrillicLetters: 'Username should contain only Latin or Cyrillic letters, spaces, or hyphens.',
        usernameMustBeNoMoreThan: 'Username must be no more than 30 characters.',
    },

    mistakesPassword: {
        passwordMustBeFilledIn: 'Password field must be filled in.',
        passwordMustContainAtLeast: 'Password must be at least 5 characters long.',
        passwordMustNotExceed: 'Password must be no more than 8 characters.',
    },

    mistakesEmail: {
        emailMustBeFilledIn: 'Field must be filled in.',
        invalidEmailFormat: 'Invalid email format.',
    },

    alreadyRegisteredError: 'This email is already registered',
}

const rus = {
    greetings: 'Регистрация в приложении',
    firstStepTitle: 'Первый этап - подтверждение адреса электронной почты',

    emailIsConfirmTitle: 'Ваша почта подтверждена',
    secondStepTitle: 'Второй этап - завершение регистрации, укажите ваше имя и пароль для входа',

    confirmEmailAddress: 'Подтвердить адрес электронной почты',

    name: 'Имя',
    email: 'Электронная почта',
    telegram: 'Telegram',
    verificationEmailLabel: "Введите адрес электронной почты, чтобы получить код для подтверждения",
    password: 'Пароль',
    verificationCodeLabel: 'Введите код, который пришел вам на почту',
    verificationEmailButton: "Отправить код на почту",
    button: 'Зарегистрироваться',

    question: 'Уже зарегистрированы?',

    signin: 'Войти',
    passwordRecovery: 'Восстановление пароля',
    enterNewPassword: 'Введите новый пароль',
    changePassword: 'Изменить пароль',
    enterEmail: 'Введите email, на него будет отправлен код для восстановления пароля',
    codeSent: 'Код отправлен на электронную почту',

    mistakesName: {
        theUsernameFieldMustBeFilledIn: 'Имя должно быть заполнено',
        theUsernameMustBeAtLeastCharactersLong: 'Имя пользователя должно быть длиной не менее 2 символов.',
        theUsernameShouldOnlyContainLatinLettersCyrillicLetters: 'Имя пользователя должно содержать только латинские буквы, кириллические буквы, пробелы или дефисы.',
        usernameMustBeNoMoreThan: 'Имя пользователя должно быть не более 30 символов.',
    },

    mistakesPassword: {
        passwordMustBeFilledIn: 'Поле пароля должно быть заполнено.',
        passwordMustContainAtLeast: 'Пороль должен быть не менее 5 символов.',
        passwordMustNotExceed: 'Пароль должен быть не более 8 символов.',
    },

    mistakesEmail: {
        emailMustBeFilledIn: 'Поле должно быть заполнено.',
        invalidEmailFormat: 'Неправильный формат электронной почты.',
    },

    alreadyRegisteredError: 'Такой email уже зарегистрирован',
}

const hebrew = {
    greetings: 'הרשמה לאפליקציה',
    firstStepTitle: 'שלב ראשון - אימות כתובת אימייל',

    emailIsConfirmTitle: 'האימייל שלך אומת',
    secondStepTitle: 'שלב שני - השלמת ההרשמה, הזן את שמך והסיסמה להתחברות',

    confirmEmailAddress: 'אשר כתובת אימייל',

    name: 'שם',
    email: 'אימייל',
    telegram: 'טלגרם',
    verificationEmailLabel: "הזן את כתובת האימייל שלך כדי לקבל קוד אימות",
    password: 'סיסמה',
    verificationCodeLabel: 'הזן את הקוד שנשלח לאימייל שלך',
    verificationEmailButton: "שלח קוד לאימייל",
    button: 'הירשם',

    question: 'כבר רשום?',

    signin: 'התחבר',
    passwordRecovery: 'שחזור סיסמה',
    enterNewPassword: 'הזן סיסמה חדשה',
    changePassword: 'שנה סיסמה',
    enterEmail: 'הזן את האימייל שלך, קוד לשחזור הסיסמה יישלח אליו',
    codeSent: 'הקוד נשלח לאימייל שלך',

    mistakesName: {
        theUsernameFieldMustBeFilledIn: 'יש למלא את השם',
        theUsernameMustBeAtLeastCharactersLong: 'שם המשתמש חייב להכיל לפחות 2 תווים.',
        theUsernameShouldOnlyContainLatinLettersCyrillicLetters: 'שם המשתמש יכול להכיל רק אותיות לטיניות או קיריליות, רווחים או מקפים.',
        usernameMustBeNoMoreThan: 'שם המשתמש לא יכול לעלות על 30 תווים.',
    },

    mistakesPassword: {
        passwordMustBeFilledIn: 'יש למלא את שדה הסיסמה.',
        passwordMustContainAtLeast: 'הסיסמה חייבת להכיל לפחות 5 תווים.',
        passwordMustNotExceed: 'הסיסמה לא יכולה לעלות על 8 תווים.',
    },

    mistakesEmail: {
        emailMustBeFilledIn: 'יש למלא את השדה.',
        invalidEmailFormat: 'פורמט אימייל לא תקין.',
    },

    alreadyRegisteredError: 'האימייל הזה כבר רשום',
}

const choose = { en, rus, hebrew };

export default choose;